import React, { forwardRef } from 'react';
import clsx from 'clsx';

export const Textarea = forwardRef(
  (
    {
      label,
      error,
      helperText,
      id,
      className,
      textareaClassName,
      rows = 4,
      required,
      ...props
    },
    ref
  ) => {
    const textareaId =
      id || (label ? `field-${label.toLowerCase().replace(/\s+/g, '-')}` : undefined);

    const baseClasses =
      'w-full px-4 py-3 bg-white rounded-xl text-sm text-slate-900 placeholder:text-slate-400 ' +
      'border transition-all focus:outline-none focus:ring-2 resize-none';

    const normalState =
      'border-slate-200 focus:border-indigo-500 focus:ring-indigo-500/50';

    const errorState =
      'border-red-300 focus:border-red-500 focus:ring-red-500/50';

    return (
      <div className={clsx('w-full', className)}>
        {label && (
          <label
            htmlFor={textareaId}
            className="block text-slate-700 mb-2 text-sm font-medium"
          >
            {label}
            {required && <span className="text-red-500 ml-0.5">*</span>}
          </label>
        )}

        <textarea
          id={textareaId}
          ref={ref}
          rows={rows}
          className={clsx(
            baseClasses,
            error ? errorState : normalState,
            textareaClassName
          )}
          aria-invalid={!!error}
          aria-describedby={helperText || error ? `${textareaId}-help` : undefined}
          {...props}
        />

        {error && (
          <p
            id={`${textareaId}-help`}
            className="text-sm text-red-600 mt-1"
          >
            {error}
          </p>
        )}

        {!error && helperText && (
          <p
            id={`${textareaId}-help`}
            className="text-sm text-slate-500 mt-1"
          >
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
